module.exports = __webpack_public_path__ + "img/Logo DIRESA-2.08326ead.png";